module.exports = __webpack_public_path__ + "img/video.24a5a304.svg";